import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { LoginService } from '../';
var SearchComponent = /** @class */ (function () {
    function SearchComponent(data, route, router, searchService) {
        this.data = data;
        this.route = route;
        this.router = router;
        this.searchService = searchService;
        this.searchfname = "";
        this.searchlname = "";
        this.request = false;
        this.query = {};
        this.searchUserRes = [];
        this.viewProfile = {};
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorPopupWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.isValidationError = true;
    }
    SearchComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SearchComponent.prototype.ngOnInit = function () {
        this.initFn();
    };
    SearchComponent.prototype.initFn = function () {
        var _this = this;
        console.log('inside ngOnInit()');
        this.route.queryParams.subscribe(function (params) { _this.query.firstName = params['fname'] || null; _this.query.lastName = params['lname'] || null; });
        this.query.baseSearchActionType = "NAME_SEARCH";
        console.log(this.query);
        this.searchService.searchUser(this.query).subscribe(function (data) {
            _this.searchUserRes = data;
            if (data.isSearchResultEmpty) {
                _this.createInfoAlert("No more results to display.");
            }
            console.log(_this.searchUserRes);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SearchComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    SearchComponent.prototype.closeErrorPopup = function () {
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorMessages = [];
        this.showErrorModalDialog = false;
    };
    SearchComponent.prototype.handleError = function (error) {
        var _this = this;
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = "Error !!";
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "30%";
                this.showErrorModalDialog = true;
            }
        }
    };
    return SearchComponent;
}());
export { SearchComponent };
//# sourceMappingURL=search.component.js.map